import { render, staticRenderFns } from "./VerificationDetailsPhotos.vue?vue&type=template&id=e71900a8&"
import script from "./VerificationDetailsPhotos.vue?vue&type=script&lang=js&"
export * from "./VerificationDetailsPhotos.vue?vue&type=script&lang=js&"
import style0 from "./VerificationDetailsPhotos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports